import React from 'react';
import classNames from 'classnames';
import SpinnerIcon from 'src/assets/icons/spinner.svg';
import styles from './Spinner.module.scss';

interface ISpinner {
  loadingText?: string;
  showText?: boolean;
  icon?: string;
  className?: string;
}

export const Spinner: React.FC<ISpinner> = ({
  loadingText = 'Loading',
  showText = true,
  icon = SpinnerIcon,
  className = '',
}) => {
  const classes = classNames(styles['spinner-container'], className);

  return (
    <div className={classes}>
      <img src={icon} className={styles['spinner-icon']} alt={loadingText} />
      {showText && <p className={styles['loading-text']}>{loadingText}</p>}
    </div>
  );
};

export default Spinner;
